import { ElementType } from 'react';

import { Box, BoxProps, styled } from '@mui/material';

export const Fieldset = styled(Box)<BoxProps<ElementType>>(() => ({
  border: 0,
  padding: 0,
  marginTop: 30,
}));
